import { getFilterValue, sameSet, setFilterValue } from "../filters/columnFilterState";

/** Chips de perfil: escrevem nas colunas booleanas Admin e Parceiro. */
export const ROLE_PRESETS = [
    { key: "todos", label: "Todos", admin: undefined, partner: undefined },
    { key: "admins", label: "Admins", admin: ["true"], partner: undefined },
    { key: "parceiros", label: "Parceiros", admin: undefined, partner: ["true"] },
];

export const applyRolePreset = (filters, preset) =>
    setFilterValue(setFilterValue(filters, "admin", preset.admin), "partner", preset.partner);

const matches = (current, expected) => (expected === undefined ? current === undefined : current !== undefined && sameSet(current, expected));

export const matchRolePreset = (filters) => {
    const admin = getFilterValue(filters, "admin");
    const partner = getFilterValue(filters, "partner");
    return ROLE_PRESETS.find((preset) => matches(admin, preset.admin) && matches(partner, preset.partner))?.key ?? null;
};
